<template>
		<a
			v-for="(alert, a) in alertsWithNew"
			:key="`alert_${a}`"
			:href="alert.url"
			class="recommendation"
		>
			<div>
				<svg-magnify-glass class="site-search-btn__icon"></svg-magnify-glass>
				<p>{{ alert.title }}</p>
			</div>
			<div>
				<p><block-alert-job-count :item="alert" :page_config="page_config"></block-alert-job-count></p>
			</div>
		</a>
</template>

<script>
import AuthMixins from '@/mixins/AuthMixins';
import AlertMixins from "@/mixins/AlertMixins";

export default {
	name: "SavedAlerts",
	mixins: [AuthMixins, AlertMixins],
	props: {
		page_config: {
			type: String,
		},
	},
	computed: {
		alertsWithNew() {
			const newAlert = {
				active: true,
				count: 0,
				title: 'Search all jobs',
				url: '/search/jobs',
				query: ''
			};

			// Add the new alert at the beginning
			return [newAlert, ...this.displayableAlerts];
		},
		displayableAlerts() {
			return this.filteredAlerts.map((alert, index) => {
				alert.url = `/search/jobs?q=${alert.query}&a=${alert.id}`;
				return alert;
			});
		},

	}
};
</script>
